import api from './client'

export interface CalendarDay {
  date: string
  incomeTotal: number
  expenseTotal: number
  transferCount: number
  transactionCount: number
}

export interface CalendarResponse {
  month: string
  monthlyIncome: number
  monthlyExpenses: number
  netSavings: number
  days: CalendarDay[]
}

export function fetchCalendar(month?: string): Promise<CalendarResponse> {
  return api.get('/calendar', { params: month ? { month } : {} }).then((r) => r.data)
}
